import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge5 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の種類' fontWeight={700} />
                <p>
                    ゴルフ会員権とは、会員制度を採用しているゴルフ場を、一般客よりも優先的に利用出来る権利を言います。
                    <br />
                    会員権の種類は主に、優先的施設利用権と預託金返還請求権を持つ「預託金会員制」と、ゴルフ場会社の株主となり優先的施設利用権が付与される「株主会員制」の２種類があり、日本のゴルフ場の約9割は「預託金会員制」となっています。
                    <br />
                    どちらもゴルフ会員権市場で需給動向に応じて取引されており、価格が変動します。
                </p>

                <Heading3 title='預託金会員制' />
                <p>
                    会員権を購入する際に会員が一定の金額を預託金としてゴルフ場会社に預け、優先的施設利用権と預託金返還請求権を取得して会員となる制度です。
                    <br />
                    通常、預託金は無利子で一定期間据え置かれますが、期日がきた場合は退会と引き換えに預託金の返還を請求することが出来ます。
                    <br />
                    ただし返還に応じるかどうかはゴルフ場によって対応が異なります。ゴルフ俱楽部が経営破綻した場合は殆ど返還される事はありません。
                </p>

                <Heading3 title='株主会員制' />
                <p>
                    会員が入会時に株主として一定の金額を出資することで、ゴルフ場経営会社の株主となり施設利用権を取得する制度です。
                    <br />
                    クラブが解散となった時には、持株比率に応じて、クラブの残余財産を請求出来る権利があります。
                    <br />
                    株主としての権利行使や売買に関しては定款に定められた規定に従います。会計処理としては有価証券となります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の時価評価と会計処理' fontWeight={700} />

                <Heading3 title='法人決算時の会計処理（時価評価）' />
                <p>
                    <strong>
                        <u>ａ）時価の考え方</u>
                    </strong>
                    <br />
                    会計上の時価と、税務上の時価は考え方が異なります。会計上の時価とは、実勢価格（相場）、又は発行会社（ゴルフ場）の財政状態に基づいて評価します。
                    <br />
                    ただ、それが難しい場合はゴルフ会員権取引業者の評価鑑定となり取引実績がある場合は取引金額が実勢価格になり、取引がない場合は売却した価格と購入した価格（需要と供給）のバランスや証券額面金額などをもとにした時価評価を用いて会計処理を行うこともあります。
                    <br />
                    税務上の時価は、発行会社（ゴルフ場）の1株あたりの純資産価額等を比較して評価します。
                    <br />
                    <br />
                    <strong>
                        <u>ｂ）会計上の処理</u>
                    </strong>
                    <br />
                    時価（相場等）が著しく下落している場合（50％以上下落、又は一定の合理的な基準のもと30％以上下落）にのみ会計処理が必要です(回復見込みがある場合を除きます)。
                    <br />
                    この場合、株主会員制のゴルフ会員権については、減損の処理（評価損の計上）を行います。ただし、株は債権ではないので、貸倒引当金の対象とはなりません。
                    <br />
                    預託金会員制のゴルフ会員権については、預託保証金を上回る部分については減損処理（評価損の計上）を行い、預託保証金の回収可能性に疑義が生じた場合（退会届出、預託金の一部切捨決定等の事実により、預託金返還請求権が顕在化した場合）に限り、貸倒引当金・貸倒損失の対象として会計処理を行うことが出来ます。
                    <br />
                    <br />
                    <strong>
                        <u>ｃ）税務上の処理</u>
                    </strong>
                    <br />
                    株主会員制のゴルフ会員権については、以下の要件に該当する場合に限り、減損処理（評価損の計上）が認められます。
                    <br />
                    ア） 会社の整理または特別清算開始の命令、破産手続・民事再生手続・会社更生手続の開始決定があった場合
                    <br />
                    イ） ゴルフ場の1株あたりの純資産価額が、会員権を取得したときのおおむね50％以上下回る場合
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='会計上の取り扱いと税務上の取り扱い' fontWeight={700} />
                <p>
                    法人が事業遂行上の必要性によりゴルフ会員権を購入したものは、法人の資産に計上します。
                    <br />
                    資産に計上する価格は、取得に要した金額であり、具体的には購入するゴルフ会員権代金、売買手数料（仲介手数料）、名義書換料（新規取得）及び入会金が入ります。
                    <br />
                    購入後の年会費、ロッカーフィー、プレーフィー、２回目以降の名義書換料は交際費となります。
                    <br />
                    ただし、名義人たる特定の役員又は使用人が専ら法人の業務に関係なく利用するためにこれらの者が負担すべきものであると認められる時は、入会に要した金額及び維持費はこれらの者に対する給与とみなされます。
                    <br />
                    また一方、ゴルフ会員権を売却して損失が出た場合は、売却損として税務上の損金計上が出来ます。会計上も税務上もそれぞれの帳簿価額から計算した売却損を計上するだけで、取り扱いは変わりません。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    ゴルフ会員権を取得すると様々な費用支出があり、その会計処理においても勘定科目や仕訳に注意する必要があります。また取得後も時価会計によって保有するゴルフ会員権の適切な資産価値を把握して、貸倒引当金の算定などについては会計上と税務上の差異をふまえながら健全な会計処理を行うことが大切となります。
                    <br />
                    今回ご案内させて頂きました内容についてのご質問や疑問点等ございましたら、当社までお気軽にお問合せください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge5;
